import { ModalWrapper } from 'src/legacy/components/Modals';
import { ShareProductStoreForm } from 'src/routes/billing/store/components/ShareProductStoreForm';
import { ProductStoreVisibility } from 'src/routes/billing/store/schema';

export const ShareProductStoreModal = ({
  onCancel: closeModal,
  handleShare,
  open,
  visibility,
  isProductStoreLoading,
  onCopyDomainUrl,
  basePortalDomain,
}: {
  onCancel: () => void;
  handleShare: () => void;
  open: boolean;
  visibility: ProductStoreVisibility;
  isProductStoreLoading: boolean;
  onCopyDomainUrl: () => void;
  basePortalDomain: string;
}) => {
  return (
    <ModalWrapper
      onClose={closeModal}
      onSuccess={handleShare}
      open={open}
      title="Publish"
      isLoading={isProductStoreLoading}
      successButtonLabel="Publish"
    >
      <ShareProductStoreForm
        visibility={visibility}
        onCopyDomainUrl={onCopyDomainUrl}
        basePortalDomain={basePortalDomain}
      />
    </ModalWrapper>
  );
};
